export default "__VITE_ASSET__jN9UOTzR__"